export const generateRandomAnswers = (correctAnswer: number, offset: number) => {
  const randomOffset = () => {
    let value;
    do {
      value = Math.floor(Math.random() * (2 * offset + 1)) - offset; // Случайное число от -offset до +offset
    } while (correctAnswer + value <= 0); // Проверяем, чтобы результат был положительным
    return value;
  };

  let answer1 = correctAnswer + randomOffset();
  let answer2 = correctAnswer + randomOffset();

  // Убедимся, что ответы не совпадают с правильным и друг с другом
  while (answer1 === correctAnswer || answer1 === answer2) {
    answer1 = correctAnswer + randomOffset();
  }

  while (answer2 === correctAnswer || answer2 === answer1) {
    answer2 = correctAnswer + randomOffset();
  }

  // Создаем массив из трех ответов и перемешиваем его
  const allAnswers = [correctAnswer, answer1, answer2];
  const shuffledAnswers = allAnswers.sort(() => Math.random() - 0.5); // Рандомное перемешивание

  return shuffledAnswers;
};
